import { useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import { USER_QUERY_KEY } from '../../hooks/user/useUser'

/**
 * Component that invalidates critical queries on app load to ensure fresh data.
 * This is defensive against stale cache issues, especially for older accounts
 * that might have outdated cached payment/team status.
 *
 * Runs once when the app mounts to force fresh data fetch from the database.
 */
export default function QueryInvalidator() {
  const queryClient = useQueryClient()

  useEffect(() => {
    queryClient.invalidateQueries({ queryKey: USER_QUERY_KEY })
    queryClient.invalidateQueries({ queryKey: ['teams'] })
    queryClient.invalidateQueries({ queryKey: ['teamMemberships'] })
    queryClient.invalidateQueries({ queryKey: ['entitlement'] })
    queryClient.invalidateQueries({ queryKey: ['entitledChallengeIds'] })
  }, [queryClient])

  return null
}
